import { createSpeakingTaskType } from '../../createTaskType';
import SpeakingGenericEditor from '../../sharedLogic/SpeakingGenericEditor';
import { createSpeakingAdditionalImageItem, createSpeakingSimpleItem } from '../../sharedLogic/speakingItemCreators';
import withProps from "@dyl/utils/withProps";
import speakingConvertToUploadFormat from "@dyl/task-types/sharedLogic/speakingConvertToUploadFormat";

export default function QuestionsAboutYou({ disableTargets, itemTemplateFunc = null }) {
    return createSpeakingTaskType({
        id: 'questions_about_you',
        label: 'Questions about you',
        skill: 'speaking',
        v2: true,
        hasRubric: false,

        editor: withProps(SpeakingGenericEditor, { disableTargets, includeContextAudioField: true }),
        createItemsTemplate: itemTemplateFunc || (() => [
            createSpeakingSimpleItem(),
            createSpeakingAdditionalImageItem(),
            createSpeakingSimpleItem(),
        ]),

        hasEndAudio: true,
        backgroundImages: { count: 1 },

        convertToUploadFormat: speakingConvertToUploadFormat,
    })
}